import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0008',
    ecrans: ['00-2'],
    params: ['id', '?ecicleint']
});
